const orgSettingsEnum = {    
    "epicBarcodeSeparator": {
        "name": "EpicBarcodeSeparator",
        "value": 100
    }
};

export default orgSettingsEnum;